




















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Thumb from '@/components/molecules/Thumb/Thumb.vue';
import WalletIcon from '@/components/icons/Wallet.vue';
import InfoIcon from '@/components/icons/Info.vue';
import { Typography } from '@/components/atoms';

@Component({
  components: {
    WalletIcon,
    InfoIcon,
    Thumb,
    Typography
  }
})
export default class CampaignSettingsExample extends Vue {
  @Prop() coins?: string | null;
  @Prop({ default: false }) filled?: boolean;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business) return '';

    return business.logo.publicPath.large;
  }

  get tPrefix() {
    return 'customerImport.campaignSettings';
  }

  get currencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
